// Action Types
export const HYBRID_ACTION_TYPES = {
    ELEMENT_EDIT_START: 'HYBRID_ELEMENT_EDIT_START',
    PRESENT_MODAL_IMAGE: 'HYBRID_PRESENT_MODAL_IMAGE',
    PRESENT_MODAL_PDF: 'HYBRID_PRESENT_MODAL_PDF',
} as const;
